<template>
    <div style="width:100%" class="q-px-none q-pt-none q-pb-sm">
        <div v-if="rules[0]" style="width:100%">
            <div class="threshold-rule-row">
                <span class="threshold-rule-prefix text--primary">{{ Translate('If') }}</span>
                <div class="threshold-rule-field threshold-rule-operator-field">
                    <q-select outlined dense
                            :label="Translate('Operator')"
                            :options="condition_types"
                            option-label="text"
                            option-value="value"
                            emit-value
                            map-options
                            v-model="rules[0].operator"
                            @update:model-value="thresholdChanged"
                            bg-color="white"
                            hide-bottom-space
                            class="full-width operator-select"
                            :error="hasOperatorError"></q-select>
                </div>

                <div class="threshold-rule-field threshold-rule-value-field" v-if="rules[0].operator != 'missing' && rules[0].operator != 'inRange' && rules[0].operator != 'notInRange'">
                    <q-input type="number" :label="Translate('Value')"
                                outlined dense :placeholder="placeholder"
                                v-model.number="rules[0].value"
                                @update:model-value="thresholdChanged"
                                bg-color="white"
                                hide-bottom-space
                                class="full-width aligned-spin-buttons"
                                :error="hasValueError">
                        <template v-slot:append>
                            <span class="text-grey-10" style="font-size: 16px;">{{ units }}</span>
                        </template>
                    </q-input>
                </div>

                <div class="threshold-rule-field threshold-rule-value-field" v-if="rules[0].operator == 'inRange' || rules[0].operator == 'notInRange'">
                    <q-input type="number" :label="Translate('From')"
                                outlined dense :placeholder="placeholder"
                                v-model.number="rules[0].value"
                                @update:model-value="thresholdChanged"
                                bg-color="white"
                                hide-bottom-space
                                class="full-width aligned-spin-buttons"
                                :error="hasFromError">
                        <template v-slot:append>
                            <span class="text-grey-10" style="font-size: 16px;">{{ units }}</span>
                        </template>
                    </q-input>
                </div>
                <div class="threshold-rule-field threshold-rule-value-field" v-if="rules[0].operator == 'inRange' || rules[0].operator == 'notInRange'">
                    <q-input type="number" :label="Translate('To')"
                                outlined dense :placeholder="placeholder"
                                v-model.number="rules[0].valueTo"
                                @update:model-value="thresholdChanged"
                                bg-color="white"
                                hide-bottom-space
                                class="full-width aligned-spin-buttons"
                                :error="hasValueToError">
                        <template v-slot:append>
                            <span class="text-grey-10" style="font-size: 16px;">{{ units }}</span>
                        </template>
                    </q-input>
                </div>
                <span class="threshold-rule-then text--primary">{{ Translate('then') }}</span>
                <div class="threshold-rule-format-field">
                    <ThresholdformatOptions ref="formatOptions" :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { appSettings } from '@/Shared/appSettings';

    import _ from 'lodash';

    import ThresholdformatOptions from './threshold_formatOptions.vue';
    import methods from '@/Shared/methods';
    import common from './common.js';

    const getCurrencySymbol = (locale, currency) => (0).toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim();

    export default {
        components: {
            ThresholdformatOptions
        },
        // Declare so parent listeners are component emits (Vue 3); same pattern as filter_*.vue (CCDEV-18136).
        emits: ['thresholdValuesChanged', 'thresholdFormatChanged'],
        data: function () {
            return {
                rules: [{ operator: 'greaterThan', value: '', valueTo: '', combiner: undefined }],
                hasOperatorError: false,
                hasValueError: false,
                hasValueToError: false,
                hasFromError: false,
            }
        },
        props: {
            item: Object,
            aggregateFunction: null,
            value: null,
            isAggregateReport: false,
            EventBus: null
        },
        created() {
            if (this.value)
            {
                console.log(`threshold_durationColumn has received an initialValue of ${JSON.stringify(this.value)}`);
            }
            // For percent: multiply by 100 for display; round to avoid float noise (e.g. 0.571 -> 57.1 not 57.10000000000001)
            const fromPercentDisplay = (v) => (v === '' || v == null) ? v : Math.round(Number(v) * 10000) / 100;
            const isPercent = this.actualColumnType() == 'percentColumn';
            this.rules[0].value = isPercent ? fromPercentDisplay(this.value.value) : this.value.value;
            this.rules[0].operator = this.value.operator;
            this.rules[0].valueTo = isPercent ? fromPercentDisplay(this.value.valueTo) : this.value.valueTo;

           

            if (this.value && this.value.type) {
                this.rules = [{
                    operator: this.value.operator,
                    value: isPercent ? fromPercentDisplay(this.value.value) : this.value.value,
                    valueTo: isPercent ? fromPercentDisplay(this.value.valueTo) : this.value.valueTo,
                }];
            }
            else if (this.value && this.value.conditions && this.value.conditions.length == 2) {
                this.rules = [{
                    operator: this.value.operator,
                    value: isPercent ? fromPercentDisplay(this.value.conditions[0].value) : this.value.conditions[0].value,
                    valueTo: isPercent ? fromPercentDisplay(this.value.conditions[0].valueTo) : this.value.conditions[0].valueTo,
                    combiner: this.value.operator,
                },{
                    operator: this.value.operator,
                    value: isPercent ? fromPercentDisplay(this.value.conditions[1].value) : this.value.conditions[1].value,
                    valueTo: isPercent ? fromPercentDisplay(this.value.conditions[1].valueTo) : this.value.conditions[1].valueTo,
                }];
            }
        },
        watch: {
            rules: function (newv) {
                if (newv.every(a => a.value !== ''))
                    this.thresholdChanged();
            },
            'item.operator': () => this.triggerValidation(),
            'item.value': () => this.triggerValidation()
        },
        computed: {
            condition_types: function () {
                return [
                    { text: this.Translate('Greater Than'), value: 'greaterThan' },
                    { text: this.Translate('Greater Than or Equal To'), value: 'greaterThanOrEqualTo' },
                    { text: this.Translate('Less Than'), value: 'lessThan' },
                    { text: this.Translate('Less Than or Equal To'), value: 'lessThanOrEqualTo' },
                    { text: this.Translate('Equals'), value: 'equals' },
                    { text: this.Translate('Does Not Equal'), value: 'notEquals' },
                    { text: this.Translate('Between'), value: 'inRange' },
                    { text: this.Translate('Not Between'), value: 'notInRange' },
                    { text: this.Translate('Missing'), value: 'missing' },
                ];
            },
            units: function() {
                console.log("Trying to figure out computed.units.  this.item is " + JSON.stringify(this.item));
                return this.actualColumnType() == 'durationColumn' ? 'sec' :
                    this.actualColumnType() == 'percentColumn' ? '%' :
                        this.actualColumnType() == 'currencyColumn' ? getCurrencySymbol(appSettings.LocaleKey, appSettings.Currency || 'USD') :
                            '#';
            },
            placeholder: function () {
                return this.actualColumnType() == 'durationColumn' ? this.Translate('Enter value in seconds') :
                    this.actualColumnType() == 'percentColumn' ? this.Translate('Enter percentage value') :
                        this.actualColumnType() == 'currencyColumn' ? this.Translate('Enter currency value') :
                            this.Translate('Enter value');
            },
            operatorRules() {
                return [
                    v => !!v || this.Translate('Please select an operator')
                ];
            },
            valueRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
            valueToRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
            valueFromRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
        },
        methods: {
            ...methods,
            actualColumnType() {
                if (this.isAggregateReport)
                {
                    if (this.item && this.item.MetricAggs && this.item.MetricAggs.Type == "bucket_script" && this.item.MetricAggs.BucketScript.ResultType){
                        return this.item.MetricAggs.BucketScript.ResultType;
                    }

                    if (this.item && this.aggregateFunction)
                    {
                        // The same mapping the metric list and the grid headers use, so a count
                        // aggregation over a duration column stops inheriting "sec".
                        return common.getAggregateColumnType(this.item.ColId, this.aggregateFunction, this.item.SourceType);
                    }
                }

                return this.item.SourceType;
            },            
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
            thresholdChanged() {
                var ruleType = this.actualColumnType() == 'durationColumn' ? 'duration' :
                this.actualColumnType() == 'percentColumn' ? 'percent' :
                    this.actualColumnType() == 'currencyColumn' ? 'currency' :
                        'number';


                if (this.rules[0].operator == 'missing')
                {
                    this.rules[0].value = "";
                    this.rules[0].valueTo = "";
                }
                // Single rule scenario is the simplest format (made popular by ag-grid)
                let firstRule = this.rules[0];
                // For percent: divide by 100 then round to avoid float precision (e.g. 57.1 -> 0.571 not 0.5710000000000001)
                const toPercentDecimal = (v) => (v === '' || v == null) ? v : Math.round(Number(v) * 10000) / 10000;
                const percentValue = this.actualColumnType() == 'percentColumn';
                this.$emit('thresholdValuesChanged', {
                    thresholdtype: "number",
                    operator: firstRule.operator,
                    value: percentValue ? toPercentDecimal(firstRule.value / 100) : firstRule.value,
                    valueTo: percentValue ? toPercentDecimal(firstRule.valueTo / 100) : firstRule.valueTo,
                    type: ruleType
                });
            },
            setItemCombiner(item, index, value) {
                console.log(`setItemCombiner[${index}] to ${value}:`);
                item.combiner = value;
                this.thresholdChanged();
            },
            addOperator() {
                this.rules.push({ operator: 'greaterThan', value: 0, valueTo: 0, combiner: undefined });
            },
            removeOperator() {
                this.rules.pop();
            },
            triggerValidation() {
                const rule = this.rules[0];
                this.hasOperatorError = common.hasValidationError(this.operatorRules, rule.operator);
                this.hasValueError = false;
                this.hasFromError = false;
                this.hasValueToError = false;

                if (rule.operator != 'missing' && rule.operator != 'inRange' && rule.operator != 'notInRange')
                    this.hasValueError = common.hasValidationError(this.valueRules, rule.value);

                if (rule.operator == 'inRange' || rule.operator == 'notInRange') {
                    this.hasFromError = common.hasValidationError(this.valueFromRules, rule.value);
                    this.hasValueToError = common.hasValidationError(this.valueToRules, rule.valueTo);
                }
            },
            validate() {
                this.triggerValidation();
                const formatValid = this.$refs.formatOptions?.validate?.() ?? true;
                const hasErrors = this.hasOperatorError || this.hasValueError || this.hasFromError || this.hasValueToError;
                return !hasErrors && formatValid;
            },
        }
    }
</script>

<style src="./threshold_row.css"></style>

<style scoped>
    .operator-select {
        width: 100%;
    }

    .aligned-spin-buttons :deep(input[type="number"]::-webkit-inner-spin-button) {
        transform: translateY(-5px);
    }

    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }
    .customHoverButton:before {
        background-color: unset !important;
        transition: unset !important;
    }
    .customHoverButton {
        background-color:unset !important;
        color: var(--v-primary-base);
    }
    .customHoverButton:hover {
        filter: brightness(80%);
    }

</style>